import React, {Component} from 'react';
import {client} from '../../Client';
import { Button, Form, Input, Message, Checkbox } from 'semantic-ui-react'
import Moment from 'moment';
import {convertNullToEmptyString, arrayToCombo, normalizeNumber} from '../../Helpers'
import ErrorMessage from '../ErrorMessage'
import TestiEditDropdown from '../TestiEditDropdown'
import {Redirect} from 'react-router-dom';
import 'moment/locale/it.js';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import PropTypes from 'prop-types';
import PdcMultiCombo from '../PdcMultiCombo'

const optionsMovimentiEntrUsc = [
    { key: 'e', text: 'Entrata', value: 'E' },
    { key: 'u', text: 'Uscita', value: 'U' },
]

const optionsMovimentiPrevDef = [
    { key: 'p', text: 'Previsionale', value: 'P' },
    { key: 'd', text: 'Definitivo', value: 'D' },
]

class MovimentiForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id, // Se undefined siamo in insert, altr in update
            inUpdate: this.props.match.params.id !== undefined,
            fields: this.getEmptyFields(),
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            error: null,
            dropdownPianoDeiContiLoading: false,
            dropdownCommesseLoading: false,
            dropdownCausaleLoading: false,
            dropdownSoggettoLoading: false,
            dropdownTipoCassaLoading: false,
            dropdownEstrattoContoLoading: false,
            pianoDeiContiList: [],
            commesseList: [],
            movimentoSaved: null,
        };

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.formIsValid = this.formIsValid.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.onInputCheckboxChange = this.onInputCheckboxChange.bind(this)
        this.onDDCausaleLoading = this.onDDCausaleLoading.bind(this)
        this.onDDSoggettoLoading = this.onDDSoggettoLoading.bind(this)
        this.onDDTipoCassaLoading = this.onDDTipoCassaLoading.bind(this)
        this.onDDEstrattoContoLoading = this.onDDEstrattoContoLoading.bind(this)
        this.onInputChangeUppercase = this.onInputChangeUppercase.bind(this)
        this.isLoadingInProgress = this.isLoadingInProgress.bind(this)
        this.comboCommesseLoaded = this.comboCommesseLoaded.bind(this)
        this.comboCommesseLoadedError = this.comboCommesseLoadedError.bind(this)
        this.onPagamentoFocus = this.onPagamentoFocus.bind(this)
    }

    isLoadingInProgress(){
        return this.state._loading || this.state.dropdownPianoDeiContiLoading || this.state.dropdownCommesseLoading || this.state.dropdownCausaleLoading || this.state.dropdownSoggettoLoading|| this.state.dropdownTipoCassaLoading;
    }

    comboPianoDeiConti(){
        this.setState({ dropdownPianoDeiContiLoading: true });
        client.loadPianoDeiContiAllList().then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        dropdownPianoDeiContiLoading: false,
                        error: null,
                        pianoDeiContiList: arrayToCombo(data.items, "idPdc", "nomeCompleto", "idPdc")
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.setState({
                        dropdownPianoDeiContiLoading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                dropdownPianoDeiContiLoading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    comboCommesseLoaded(response){

        if (response.ok)
        {
            response.json().then((data)=>{
                this.setState({
                    dropdownCommesseLoading: false,
                    error: null,
                    commesseList: arrayToCombo(data.items, "idCommessa", "nomeCompleto", "idCommessa")
                })
            })
        }
        else if (response.status === 401)
        {
            this.props.history.push("/login")
        }            else
        {
            response.json().then((errore) => {
                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    dropdownCommesseLoading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: errore.title, msg: errore.msg},
                    inError: true
                });
            });
        }
    }

    comboCommesseLoadedError(error){
        let fieldErrorsText = []
        let fieldErrors = {}
        this.setState({
            dropdownCommesseLoading: false,
            fieldErrors: fieldErrors,
            fieldErrorsText: fieldErrorsText,
            errorTitle: '',
            error: {title: "Errore di rete imprevisto", msg: error.message},
            inError: true
        });
    }

    comboCommesse(){
        this.setState({ dropdownCommesseLoading: true });
        if(this.state.inUpdate){
            client.loadCommesseTutteList().then(this.comboCommesseLoaded).catch(this.comboCommesseLoadedError);
        }
        else{
            client.loadCommesseNonArchiviateList().then(this.comboCommesseLoaded).catch(this.comboCommesseLoadedError);
        }
    }

    componentWillMount() {
        // Carica gli elenchi base
        this.comboPianoDeiConti();
    }

    componentDidMount() {
        if (this.state.inUpdate)
        {
            this.setState({ _loading: true });
            client.loadMovimento(this.state.id).then(
                (response) => {
                    if (response.ok){
                        response.json().then((movimento) => {

                            let fields = convertNullToEmptyString(movimento);
                            fields.data = Moment(movimento.data).format("YYYY-MM-DD")
                            fields.dataEmissioneDoc = movimento.dataEmissioneDoc ?  Moment(movimento.dataEmissioneDoc).format("YYYY-MM-DD") : '';
                            fields.idPdc = fields.idPdc === undefined ? null : fields.idPdc.idPdc;
                            fields.idCommessa = fields.idCommessa === undefined ? null : fields.idCommessa.idCommessa;

                            this.setState({ _loading: false, fields: fields,  fieldErrors: {},
                                fieldErrorsText: [], inError: false, error: null, movimentoSaved: movimento});
                            this.comboCommesse();
                            this.forceUpdate();
                        })
                    }
                    else if (response.status === 401)
                    {
                        this.props.history.push("/login")
                    }                    else
                    {
                        response.json().then((errore) => {
                            let fieldErrorsText = []
                            let fieldErrors = {}
                            this.setState({
                                _loading: false,
                                fieldErrors: fieldErrors,
                                fieldErrorsText: fieldErrorsText,
                                errorTitle: '',
                                error: {title: errore.title, msg: errore.msg},
                                inError: true
                            });
                        });

                    }
            }).catch((error) => {

                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    _loading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: "Errore di rete imprevisto", msg: error.message},
                    inError: true
                });

            });
        }
        else
        {
            this.comboCommesse();
            let fieldsStored = client.getSessionStorage("MovimentiForm_LastItemSaved");
            if (fieldsStored !== null){
                let fields = this.state.fields;
                fields["data"] = fieldsStored["data"];
                this.setState({fields:fields});
            }
        }

    }

    getEmptyFields() {
        return {
            'data' : Moment().format("YYYY-MM-DD"),
            'dataEmissioneDoc' : '',
            'annoComp' : Moment().format("YYYY"),
            'soggetto' : '',
            'idCommessa' : undefined,
            'corrispettivo' : '0.00',
            'pagamento' : '0.00',
            'onerefisc' : '0.00',
            'onereprev' : '0.00',
            'altroimp' : '0.00',
            'ritenuta' : '0.00',
            'tipoCassa': '',
            'causale' : '',
            'forma' : '',
            'entrUsc' : 'U',
            'prevDef' : 'D',
            'estrConto' : '',
            'idPdc' : undefined,
            'riservato' : false,
        }
    }

    formIsValid(formData) {
        // Validazione dati
        let fieldErrorsText = []
        let fieldErrors = {}

        if (formData.data === "Invalid date"){
            fieldErrors["data"] = true;
            fieldErrorsText.push("La data del movimento non è nel formato corretto (gg/mm/aaaa)");
        }

        if (this.state.fields.idPdc === undefined )
        {
            fieldErrors["idPdc"] = true;
            fieldErrorsText.push("Occorre specificare il Piano dei Conti di questo movimento");
        }

        if (Object.keys(fieldErrors).length > 0)
        {
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle:"La form contiene errori",
                inError: true
            })
            return false;
        }
        return true;
    }

    handleCancel(e) {

        e.preventDefault();
        this.setState({cancelSuccess: true})
    }

    handleSubmit(e) {
        e.preventDefault();
        let formData = this.state.fields;

        // Validazione form
        if (!this.formIsValid(this.state.fields)){
            return;
        }


        // Salvataggio sul server
        formData["corrispettivo"] = normalizeNumber(formData["corrispettivo"]);
        formData["pagamento"] = normalizeNumber(formData["pagamento"]);
        

        client.setSessionStorage("MovimentiForm_LastItemSaved", formData);

        this.setState({_loading: true});
        client.saveMovimento(
            formData,
            this.state.fields.idMovimento
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    let fields = this.state.fields;
                    fields["idMovimento"] = data.idMovimento;
                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        saveSuccess: true,
                        successTitle: "Salvataggio movimento",
                        successText: "Il movimento è stato salvato correttamente",
                        fields: fields,
                        movimentoSaved: data,
                    });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    onInputChange(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields, fieldErrors: {}, fieldErrorsText:[], errorTitle:'', inError: false });
        }
    }

    onInputCheckboxChange(a1, {name, checked}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = checked;
            this.setState({ fields });
        }
    }

    onPagamentoFocus() {
        console.log("onPagamentoFocus!");

        const fields = this.state.fields;
        if (fields.pagamento === undefined || fields.pagamento === 0 || fields.pagamento === "0.00" || fields.pagamento === ""|| fields.pagamento === "NaN"){
            fields["pagamento"] = this.calcolaPagamento(fields);
            fields["pagamentoCalcolato"] = fields["pagamento"];
            this.setState({ fields, fieldErrors: {}, fieldErrorsText:[], errorTitle:'', inError: false });
        }

    }

    calcolaPagamento(fields){
        let corrispettivo = parseFloat(fields["corrispettivo"]);
        let onereprev = parseFloat(fields["onereprev"]);
        let onerefisc = parseFloat(fields["onerefisc"]);
        let altroimp = parseFloat(fields["altroimp"]);
        let ritenuta = parseFloat(fields["ritenuta"]);
        let dare = (corrispettivo + onereprev + onerefisc + altroimp - ritenuta).toFixed(2);
        return dare;
    }

    reimpostaValoriStandard(){
        const fields = this.state.fields;
        fields["pagamentoCalcolato"] = fields["pagamento"] = this.calcolaPagamento(fields);
        this.setState({ fields, fieldErrors: {}, fieldErrorsText:[], errorTitle:'', inError: false });
    }

    onInputChangeUppercase(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;

            fields[name] = value.toUpperCase();

            this.setState({ fields });
        }
    }

    onDDCausaleLoading(value){
        this.setState({dropdownCausaleLoading: value})
    }

    onDDSoggettoLoading(value){
        this.setState({dropdownSoggettoLoading: value})
    }
    onDDTipoCassaLoading(value){
        this.setState({dropdownTipoCassaLoading: value})
    }
    onDDEstrattoContoLoading(value){
        this.setState({dropdownEstrattoContoLoading: value})
    }

    render() {

        if (this.state.error != null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let formInError = this.state.fieldErrorsText.length > 0;

        if (this.state.saveSuccess || this.state.cancelSuccess){
            return <Redirect to={ {
                pathname: '/app/movimenti/list',
                state: {
                    from: this.props.location,
                    item: this.state.movimentoSaved,
                },
            }}/>
        }
        let titleMsg = this.state.inUpdate ?
            <h3 className="ui block attached top header"><i className="edit icon"></i> Modifica Movimento</h3>
            :
            <h3 className="ui block attached top header"><i className="add square icon"></i> Nuovo Movimento</h3>
            
        let riservatoCheckBox = null;
        if (client.getCurrentUser().isrolemovimentiext === true){
            riservatoCheckBox = (<Form.Field width={2} >
                         <label>Riservato</label>
                         <Checkbox name="riservato" defaultIndeterminate={false} toggle checked={this.state.fields.riservato} onChange={this.onInputCheckboxChange} />
                        </Form.Field>);
        }
        return (
            <div>
            <Form onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>

                {titleMsg}
                <div className="ui attached segment">
                <Form.Group widths="4">
                    <Form.Dropdown label='Tipo' name='entrUsc' required={true} fluid selection options={optionsMovimentiEntrUsc} value={''+this.state.fields.entrUsc} onChange={this.onInputChange}/>
                    <Form.Dropdown label='Prev/Def' name='prevDef' required={true} fluid selection options={optionsMovimentiPrevDef} value={''+this.state.fields.prevDef} onChange={this.onInputChange}/>

                    <Form.Field width={4}>
                        <label>Data</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => {this.onInputChange(null, {name: 'data', value: dateString})}}
                            value={this.state.fields.data}
                            required={true}
                            displayFormat='DD/MM/YYYY'
                            returnFormat='YYYY-MM-DD'
                        />
                    </Form.Field>

                    {/*<Form.Input label='Data' type="date" required={true} name='data' value={this.state.fields.data} error={this.state.fieldErrors["data"]} onChange={this.onInputChange}/>*/}
                    <Form.Field label="Anno di competenza" type="number" required={false} control={Input} name='annoComp' pattern="[0-9][0-9][0-9][0-9]"  placeholder='' maxLength='4' value={this.state.fields.annoComp}  onChange={this.onInputChange} error={this.state.fieldErrors["annoComp"]}/>
                </Form.Group>
                <Form.Group widths='4'>
                    <TestiEditDropdown tipo="MFORM" label='Forma di pagamento' name='forma' additionLabel='Nuova forma: '
                                       placeholder="Scegli..."
                                       maxlength={255}
                                       value={''+this.state.fields.forma}
                                       error={this.state.fieldErrors["forma"]}
                                       onChange={this.onInputChange}
                    />
                    {/*<TestiDropdown tipo="MFORM" label='Forma di pagamento' name='forma' additionLabel='Nuova forma: '*/}
                                   {/*maxlength={20}*/}
                                   {/*value={''+this.state.fields.forma}*/}
                                   {/*error={this.state.fieldErrors["forma"]}*/}
                                   {/*onChange={this.onInputChange}/>*/}
                    <TestiEditDropdown tipo="ESCON" label='Estratto Conto' name='estrConto' additionLabel='Nuovo estratto conto: '
                                       placeholder="AAAA/NN/L"
                                       maxlength={9}
                                       pattern="[0-9][0-9][0-9][0-9]/[0-9][0-9]/[A-Za-z]"
                                       value={''+this.state.fields.estrConto}
                                       error={this.state.fieldErrors["estrConto"]}
                                       onChange={this.onInputChangeUppercase}
                                       onLoading={this.onDDEstrattoContoLoading}
                    />
                    <Form.Field width={4}>
                        <label>Data Emissione Doc.</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => {
                                
                                this.onInputChange(null, {name: 'dataEmissioneDoc', value: dateString === "Invalid date"?"":dateString})}}
                            value={this.state.fields.dataEmissioneDoc}
                            required={false}
                            displayFormat='DD/MM/YYYY'
                            returnFormat='YYYY-MM-DD'
                            onClear={() => {                            
                                this.onInputChange(null, {name: 'dataEmissioneDoc', value: ""})
                            }}
                        />
                    </Form.Field>
                    {riservatoCheckBox}
                    {/*<Form.Input label='Estratto Conto' placeholder='AAAA/NN/L' name='estrConto' autoComplete="on"  pattern="[0-9][0-9][0-9][0-9]/[0-9][0-9]/[A-Za-z]"  value={this.state.fields.estrConto} error={this.state.fieldErrors["estrConto"]} onChange={this.onInputChangeUppercase}/>*/}
                </Form.Group>

                    <Form.Group widths='8'> 
                        <Form.Input label='Corrispettivo'  name='corrispettivo'  pattern="^-{0,1}[0-9]*(\.[0-9]{1,2}){0,1}$" autoComplete="nope" required={true}  value={this.state.fields.corrispettivo} error={this.state.fieldErrors["corrispettivo"]} onChange={this.onInputChange}/>
                        <Form.Input label='Onere prev.'  name='onereprev'  pattern="^-{0,1}[0-9]*(\.[0-9]{1,2}){0,1}$" autoComplete="nope" required={false}  value={this.state.fields.onereprev} error={this.state.fieldErrors["onereprev"]} onChange={this.onInputChange}/>
                        <TestiEditDropdown tipo="MTPCS" label='Tipo Cassa' name='tipoCassa' additionLabel='Nuovo Tipo di Cassa: '
                                       placeholder="Tipo di cassa"
                                       maxlength={255}
                                       value={''+this.state.fields.tipoCassa}
                                       error={this.state.fieldErrors["tipoCassa"]}
                                       onChange={this.onInputChange}
                                       onLoading={this.onDDTipoCassaLoading}
                        />
                        <Form.Input label='Onere fisc.'  name='onerefisc'  pattern="^-{0,1}[0-9]*(\.[0-9]{1,2}){0,1}$" autoComplete="nope" required={false}  value={this.state.fields.onerefisc} error={this.state.fieldErrors["onerefisc"]} onChange={this.onInputChange}/>
                        <Form.Input label='Altro'  name='altroimp'  pattern="^-{0,1}[0-9]*(\.[0-9]{1,2}){0,1}$" autoComplete="nope" required={false}  value={this.state.fields.altroimp} error={this.state.fieldErrors["altroimp"]} onChange={this.onInputChange}/>
                        <Form.Input label='Ritenuta'  name='ritenuta'  pattern="^-{0,1}[0-9]*(\.[0-9]{1,2}){0,1}$" autoComplete="nope" required={false}  value={this.state.fields.ritenuta} error={this.state.fieldErrors["ritenuta"]} onChange={this.onInputChange}/>
                        <Form.Input label='Pagamento'  name='pagamento'  pattern="^-{0,1}[0-9]*(\.[0-9]{1,2}){0,1}$" autoComplete="nope" required={true}  value={this.state.fields.pagamento} error={this.state.fieldErrors["pagamento"]} onChange={this.onInputChange} onFocus={this.onPagamentoFocus}/>
                    </Form.Group>


                    <TestiEditDropdown tipo="MSOGG" label='Soggetto' name='soggetto' additionLabel='Nuovo soggetto: '
                                       placeholder="Parte verso la quale/dalla quale è originato il movimento"
                                   maxlength={255}
                                   value={''+this.state.fields.soggetto}
                                   error={this.state.fieldErrors["soggetto"]}
                                   onChange={this.onInputChange}
                                   onLoading={this.onDDSoggettoLoading}
                    />
                    {/*<TestiDropdown tipo="MSOGG" label='Soggetto' name='soggetto' additionLabel='Nuovo soggetto: '*/}
                                   {/*maxlength={255}*/}
                                   {/*value={''+this.state.fields.soggetto}*/}
                                   {/*error={this.state.fieldErrors["soggetto"]}*/}
                                   {/*onChange={this.onInputChange}*/}
                                   {/*onLoading={this.onDDSoggettoLoading}*/}
                    {/*/>*/}
                    <TestiEditDropdown tipo="MCAUS" label='Causale' name='causale' additionLabel='Nuova causale: '
                                       placeholder="Ragione del movimento"
                                       maxlength={255}
                                       value={''+this.state.fields.causale}
                                       error={this.state.fieldErrors["causale"]}
                                       onChange={this.onInputChange}
                                       onLoading={this.onDDCausaleLoading}
                    />
                    {/*<TestiDropdown tipo="MCAUS" label='Causale' name='causale' additionLabel='Nuova causale: '*/}
                                   {/*maxlength={255}*/}
                                   {/*value={''+this.state.fields.causale}*/}
                                   {/*error={this.state.fieldErrors["causale"]}*/}
                                   {/*onChange={this.onInputChange}*/}
                                   {/*onLoading={this.onDDCausaleLoading}*/}
                    {/*/>*/}

                {/*<Form.Dropdown width={16} loading={this.state.dropdownPianoDeiContiLoading} required={true} label='Piano dei Conti' name='idPdc' fluid search selection options={this.state.pianoDeiContiList} value={this.state.fields.idPdc}*/}
                               {/*onChange={this.onInputChange} error={this.state.fieldErrors["idPdc"]} />*/}
                <PdcMultiCombo
                    label='Piano dei Conti'
                    required={true}
                    idPdc={this.state.fields.idPdc}
                    onChange={this.onInputChange}
                />
                <Form.Dropdown width={16} loading={this.state.dropdownCommesseLoading} placeholder='Commessa' name='idCommessa' fluid search selection options={this.state.commesseList} value={this.state.fields.idCommessa}
                           onChange={this.onInputChange} error={this.state.fieldErrors["idCommessa"]} />
                </div>


                <Message
                    error
                    header={this.state.errorTitle}
                    list={this.state.fieldErrorsText}
                />
                <Message
                    success
                    header={this.state.successTitle}
                    content={this.state.successText}
                    icon={"smile"}
                />
                <p></p>
                <div className="ui grid">
                    <div className="right aligned eight wide column">
                        <a onClick={this.handleCancel}  className="ui right floated  secondary  button"><i className="undo icon"/>Annulla</a>
                    </div>
                    <div className="left aligned eight wide column">
                        <Button primary type='submit' loading={this.isLoadingInProgress()}><i className="save icon"/> Salva</Button>
                    </div>
                </div>
            </Form>
            </div>
        )
    }
}

MovimentiForm.contextTypes = {
    router: PropTypes.object
}

export default MovimentiForm;




/** WEBPACK FOOTER **
 ** ./src/components/movimenti/MovimentiForm.js
 **/